import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchByProgram,
  fetchByGraduationYear,
  deleteStudent,
  retractStudentOffice,
  fetchMembersByLastName,
} from "../../../actions/student.action";
import { userTypes } from "../../../utils/helpers/constants";
// import { filterData } from "../../../utils/helpers/dataHelper";
import AntTable from "./AntTable";
import FileUploadModal from "../../../components/modals/FileUploadModal";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useHistory } from "react-router-dom";

export default function Body({
  profile,
  deleteStatusState,
  studentList,
  studentListLoading,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [filterKey, setFilterKey] = useState("");

  const handleApproval = (item) => {};

  const handleRole = (item) => {};

  const handleView = (item) => {};

  const handleDelete = (item) => {
    const id = item.id;
    const name = item.feeType;
    const action = "delete";
    const payload = { id, name, action };

    dispatch(deleteStudent(payload));
  };

  const handleRetractOffice = (item) => {
    const id = item.id;
    const name = item.feeType;
    const action = "retract";
    const payload = { id, name, action };

    dispatch(retractStudentOffice(payload));
  };

  const handleSearch = (name) => {
    setFilterKey(name);
    if (name.trim() !== "" && name.length > 3) {
      dispatch(fetchMembersByLastName(name));
    }
  };

  const handleFilter = (payload) => {
    const { category, value } = payload;
    const pageAble = { page: 0, size: 1000000 };
    switch (category) {
      case "YEAR":
        dispatch(fetchByGraduationYear(value, pageAble));
        break;
      case "PROGRAM":
        dispatch(fetchByProgram(value, pageAble));
        break;
      default:
        break;
    }
  };

  console.log("studentList ====> ", studentList);

  return (
    <div className="app-content hor-content">
      <div className="container mx-2 md:container md:mx-auto">
        <AiOutlineArrowLeft
          size={25}
          onClick={() => history.goBack()}
          className="mt-2 cursor-pointer"
        />
        {[profile["userType"]] === userTypes.ROLE_USER ? null : (
          <div className="page-header">
            <div>
              <h1 className="page-title">Members</h1>
            </div>
          </div>
        )}
        <div className="p-2">
          <AntTable
            handleView={(item) => handleView(item)}
            handleSearch={(value) => handleSearch(value)}
            // studentList={filterData(studentList, filterKey, ["matricNumber"])}
            studentList={studentList}
            statusState={studentListLoading}
            deleteStatusState={deleteStatusState}
            handleApproval={(item) => handleApproval(item)}
            handleCreate={() => setOpen(true)}
            handleDelete={(item) => handleDelete(item)}
            handleFilter={(item) => handleFilter(item)}
            handleRole={(item) => handleRole(item)}
            retractOffice={(item) => handleRetractOffice(item)}
          />
        </div>
      </div>

      <FileUploadModal
        open={open}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
      />
    </div>
  );
}
